export function toCurrency (value) {
    if (!value) {
        return 0;
    } else {
        return value.toLocaleString();
    }
}
